import { Component, Input, OnInit } from '@angular/core';
import { StepDescription } from '../../models/intefaces/step-description';
import { ClockCircleOutline } from '@ant-design/icons-angular/icons';
import { IconService } from '@ant-design/icons-angular';

@Component({
  selector: 'app-steps-description',
  templateUrl: './steps-description.component.html',
  styleUrls: ['./steps-description.component.scss'],
})
export class StepsDescriptionComponent implements OnInit {
  @Input()
  public stepsDescription: StepDescription[] = [];

  constructor(private readonly iconService: IconService) {}

  ngOnInit(): void {
    this.iconService.addIcon(ClockCircleOutline);
  }

  hasDescriptions(): boolean {
    return this.stepsDescription.length > 0;
  }
}
